import { Server } from '~/lib/ApiModel';
import { IApiClient } from '~/lib/ApiClient';
import { loadAllItems } from '~/lib/helper/PagingHelper';
import { AsyncStore } from './AsyncStore';
import { computed, makeObservable } from 'mobx';
import { orderBy } from '../helper/ArrayHelper';

export class ServersStore extends AsyncStore<Server[]> {
    constructor(apiClient: IApiClient) {
        super(async () => {
            const res = await loadAllItems((link) => apiClient.getServers(link));
            return orderBy(res, (s) => s.name);
        }, []);
        makeObservable(this);
    }

    @computed
    get items() {
        return this.item;
    }
}
